import { render } from "./R_ServicioAdmin_Activo.vue?vue&type=template&id=55410788"
import script from "./R_ServicioAdmin_Activo.vue?vue&type=script&lang=js"
export * from "./R_ServicioAdmin_Activo.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__